"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const TrialsResultsMainIntro_vue_1 = __importDefault(require("../TrialsResultsMainIntro.vue"));
const TrialsResultsMainTopAction_vue_1 = __importDefault(require("../TrialsResultsMainTopAction.vue"));
const FastBulkDownload_vue_1 = __importDefault(require("./FastBulkDownload.vue"));
const ConfigurationScheme_vue_1 = __importDefault(require("./ConfigurationScheme.vue"));
let TrialsConfiguration = class TrialsConfiguration extends vue_property_decorator_1.Vue {
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    /*     configurationData:Configuration = new Configuration({
            locations: [
                {
                    "id": 4944,
                    "name": "Prof. Sheridan Gusikowski III",
                    "crop": "Avocado",
                    "hook": "",
                    "treatments": [
                        {
                            "name": "Control",
                            "id": 1870,
                            "is_control": true,
                            "hook": "",
                            "type": "Fertilizer",
                            "lineage": "Prof. Sheridan Gusikowski III + Control",
                            "times": [
                                {
                                    "date": "1982-12-02 12:12:23",
                                    "time": 0,
                                    "order": 0,
                                    "hook": "",
                                    "lineage": "Prof. Sheridan Gusikowski III + Control + T0",
                                    "samples": [
                                        {
                                        "id": 1199648,
                                        "code": "0000HT"
                                        },
                                        {
                                        "id": 1199649,
                                        "code": "000L6K"
                                        },
                                        {
                                        "id": 1199650,
                                        "code": "000S9F"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "2010-05-16 01:05:05",
                                    "time": 1,
                                    "order": 1,
                                    "hook": "",
                                    "lineage": "Prof. Sheridan Gusikowski III + Control + T1",
                                    "samples": [
                                        {
                                        "id": 1199654,
                                        "code": "000Y2S"
                                        },
                                        {
                                        "id": 1199655,
                                        "code": "000511"
                                        },
                                        {
                                        "id": 1199656,
                                        "code": "0001V2"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "1983-01-11 01:01:39",
                                    "time": 2,
                                    "order": 2,
                                    "hook": "",
                                    "lineage": "Prof. Sheridan Gusikowski III + Control + T2",
                                    "samples": [
                                        {
                                        "id": 1199660,
                                        "code": "000NKN"
                                        },
                                        {
                                        "id": 1199661,
                                        "code": "000HC7"
                                        },
                                        {
                                        "id": 1199662,
                                        "code": "000EN3"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                }
                            ].map((time:any) => new TimeConfiguration(time))
                        },
                        {
                            "name": "Evangeline Klein",
                            "id": 1875,
                            "is_control": false,
                            "type": "Fertilizer",
                            "hook": "",
                            "lineage": "Prof. Sheridan Gusikowski III + Evangeline Klein",
                            "times": [
                                {
                                    "date": "1991-07-28 11:07:18",
                                    "time": 0,
                                    "order": 0,
                                    "hook": "",
                                    "lineage": "Prof. Sheridan Gusikowski III + Evangeline Klein + T0",
                                    "samples": [
                                        {
                                        "id": 1199630,
                                        "code": "000WDK"
                                        },
                                        {
                                        "id": 1199631,
                                        "code": "000D8L"
                                        },
                                        {
                                        "id": 1199632,
                                        "code": "00072G"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "1992-09-24 08:09:04",
                                    "time": 1,
                                    "order": 1,
                                    "hook": "",
                                    "lineage": "Prof. Sheridan Gusikowski III + Evangeline Klein + T1",
                                    "samples": [
                                        {
                                        "id": 1199636,
                                        "code": "000R25"
                                        },
                                        {
                                        "id": 1199637,
                                        "code": "000W6E"
                                        },
                                        {
                                        "id": 1199638,
                                        "code": "000XTJ"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "2006-07-02 04:07:56",
                                    "time": 2,
                                    "order": 2,
                                    "hook": "",
                                    "lineage": "Prof. Sheridan Gusikowski III + Evangeline Klein + T2",
                                    "samples": [
                                        {
                                        "id": 1199642,
                                        "code": "000UTR"
                                        },
                                        {
                                        "id": 1199643,
                                        "code": "000KS5"
                                        },
                                        {
                                        "id": 1199644,
                                        "code": "000GGB"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                }
                            ].map((time:any) => new TimeConfiguration(time))
                        }
                    ].map((t:any) => new TreatmentConfiguration(t))
                },
                {
                    "id": 4945,
                    "name": "Elliot Greenholt II",
                    "crop": "Avocado",
                    "hook": "",
                    "lineage": "Elliot Greenholt II",
                    "treatments": [
                        {
                            "name": "Control",
                            "is_control": true,
                            "id": 1870,
                            "type": "Fertilizer",
                            "hook": "",
                            "lineage": "Elliot Greenholt II + Control",
                            "times": [
                                {
                                    "date": "1981-11-09 05:11:09",
                                    "time": 0,
                                    "order": 0,
                                    "hook": "",
                                    "lineage": "Elliot Greenholt II + Control + T0",
                                    "samples": [
                                        {
                                        "id": 1199651,
                                        "code": "0009RF"
                                        },
                                        {
                                        "id": 1199652,
                                        "code": "000SB6"
                                        },
                                        {
                                        "id": 1199653,
                                        "code": "000WT5"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "1982-06-30 12:06:48",
                                    "time": 1,
                                    "order": 1,
                                    "hook": "",
                                    "lineage": "Elliot Greenholt II + Control + T1",
                                    "samples": [
                                        {
                                        "id": 1199657,
                                        "code": "000KP3"
                                        },
                                        {
                                        "id": 1199658,
                                        "code": "0005MS"
                                        },
                                        {
                                        "id": 1199659,
                                        "code": "000Q9O"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "2014-08-17 11:08:57",
                                    "time": 2,
                                    "order": 2,
                                    "hook": "",
                                    "lineage": "Elliot Greenholt II + Control + T2",
                                    "samples": [
                                        {
                                        "id": 1199663,
                                        "code": "000T1M"
                                        },
                                        {
                                        "id": 1199664,
                                        "code": "000ZUE"
                                        },
                                        {
                                        "id": 1199665,
                                        "code": "0006N1"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                }
                            ].map((time:any) => new TimeConfiguration(time))
                        },
                        {
                            "name": "Evangeline Klein",
                            "id": 1875,
                            "is_control": false,
                            "type": "Fertilizer",
                            "hook": "",
                            "lineage": "Elliot Greenholt II + Evangeline Klein",
                            "times": [
                                {
                                    "date": "1991-05-27 10:05:14",
                                    "time": 0,
                                    "order": 0,
                                    "hook": "",
                                    "lineage": "Elliot Greenholt II + Evangeline Klein + T0",
                                    "samples": [
                                        {
                                        "id": 1199633,
                                        "code": "000B0H"
                                        },
                                        {
                                        "id": 1199634,
                                        "code": "000ZMO"
                                        },
                                        {
                                        "id": 1199635,
                                        "code": "00016H"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "2018-06-30 02:06:50",
                                    "time": 1,
                                    "order": 1,
                                    "hook": "",
                                    "lineage": "Elliot Greenholt II + Evangeline Klein + T1",
                                    "samples": [
                                        {
                                        "id": 1199639,
                                        "code": "000HXS"
                                        },
                                        {
                                        "id": 1199640,
                                        "code": "0000ED"
                                        },
                                        {
                                        "id": 1199641,
                                        "code": "000120"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                },
                                {
                                    "date": "2014-03-17 06:03:48",
                                    "time": 2,
                                    "order": 2,
                                    "hook": "",
                                    "lineage": "Elliot Greenholt II + Evangeline Klein + T2",
                                    "samples": [
                                        {
                                        "id": 1199645,
                                        "code": "00079L"
                                        },
                                        {
                                        "id": 1199646,
                                        "code": "000L70"
                                        },
                                        {
                                        "id": 1199647,
                                        "code": "000LK5"
                                        }
                                    ].map((s:any) => new SampleConfiguration(s)),
                                    "samplesTotalThisTime": 3,
                                    "samplesAssignedForTime": 3
                                }
                            ].map((time:any) => new TimeConfiguration(time))
                        }
                    ].map((t:any) => new TreatmentConfiguration(t))
                }
            ].map((l:any) => new LocationConfiguration(l))
        }) */
    downloadCSVConfig() {
        this.$emit('downloadCSVConfig');
    }
    updateLocationsSelected(model) {
        /*         console.log('Locations')
                console.log(model) */
    }
    updateTreatmentsSelected(model) {
        /*         console.log('Treatments')
                console.log(model) */
    }
    updateTimesSelected(model) {
        /*         console.log('Times')
                console.log(model) */
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], TrialsConfiguration.prototype, "configurationData", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TrialsConfiguration.prototype, "theme", void 0);
TrialsConfiguration = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            TrialsResultsMainIntro: TrialsResultsMainIntro_vue_1.default,
            TrialsResultsMainTopAction: TrialsResultsMainTopAction_vue_1.default,
            FastBulkDownload: FastBulkDownload_vue_1.default,
            ConfigurationScheme: ConfigurationScheme_vue_1.default
        },
    })
], TrialsConfiguration);
exports.default = TrialsConfiguration;
